export const WidgetsActions = Object.freeze({
	ShowEditWidgetFormForCell: 'widgets-show-edit-widget-form-for-cell',
	ShowEditWidgetFormForSelectedCell: 'widgets-show-edit-widget-form-for-selected-cell',
	ToggleWidgetSettings: 'widgets-toggle-settings',
	ShowEditWidgetFormDefault: 'widgets-show-edit-widget-form-default',
});
